import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | Black Ridge Construction" noIndex />
      <section className="section-pad bg-br-black text-white">
        <div className="container-br max-w-2xl text-center">
          <div className="br-eyebrow text-br-bronze-2">404</div>
          <h1 className="br-headline text-4xl sm:text-5xl mt-3">Page Not Found</h1>
          <p className="mt-4 text-gray-300">The page you were looking for could not be found. Try the homepage or get in touch.</p>
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            <Link to="/" className="br-btn-primary">Back to Home</Link>
            <Link to="/contact" className="br-btn-secondary">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
